"use strict";

var _toConsumableArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator3 = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step3;
    try {
      var _loop = function _loop() {
        var key = _step3.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
  return to;
};
var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  createDocumentNode: function createDocumentNode() {
    return _createDocumentNode;
  },
  createNode: function createNode() {
    return _createNode;
  },
  findDescendant: function findDescendant() {
    return _findDescendant;
  },
  getAncestorNode: function getAncestorNode() {
    return _getAncestorNode;
  },
  getBlockAbove: function getBlockAbove() {
    return _getBlockAbove;
  },
  getChildren: function getChildren() {
    return _getChildren;
  },
  getEdgeBlocksAbove: function getEdgeBlocksAbove() {
    return _getEdgeBlocksAbove;
  },
  getLastChild: function getLastChild() {
    return _getLastChild;
  },
  getLastChildPath: function getLastChildPath() {
    return _getLastChildPath;
  },
  getLastNodeByLevel: function getLastNodeByLevel() {
    return _getLastNodeByLevel;
  },
  getMark: function getMark() {
    return _getMark;
  },
  getNextNodeStartPoint: function getNextNodeStartPoint() {
    return _getNextNodeStartPoint;
  },
  getNextSiblingNodes: function getNextSiblingNodes() {
    return _getNextSiblingNodes;
  },
  getNodesRange: function getNodesRange() {
    return _getNodesRange;
  },
  getOperations: function getOperations() {
    return _getOperations;
  },
  getPointBeforeLocation: function getPointBeforeLocation() {
    return _getPointBeforeLocation;
  },
  getPointFromLocation: function getPointFromLocation() {
    return _getPointFromLocation;
  },
  getPointNextToVoid: function getPointNextToVoid() {
    return _getPointNextToVoid;
  },
  getPreviousBlockById: function getPreviousBlockById() {
    return _getPreviousBlockById;
  },
  getPreviousNodeEndPoint: function getPreviousNodeEndPoint() {
    return _getPreviousNodeEndPoint;
  },
  getPreviousPath: function getPreviousPath() {
    return _getPreviousPath;
  },
  getPreviousSiblingNode: function getPreviousSiblingNode() {
    return _getPreviousSiblingNode;
  },
  getRangeBefore: function getRangeBefore() {
    return _getRangeBefore;
  },
  getRangeFromBlockStart: function getRangeFromBlockStart() {
    return _getRangeFromBlockStart;
  },
  getSelectionText: function getSelectionText() {
    return _getSelectionText;
  },
  insertElements: function insertElements() {
    return _insertElements;
  },
  insertEmptyElement: function insertEmptyElement() {
    return _insertEmptyElement;
  },
  isAncestorEmpty: function isAncestorEmpty() {
    return _isAncestorEmpty;
  },
  isBlockAboveEmpty: function isBlockAboveEmpty() {
    return _isBlockAboveEmpty;
  },
  isBlockTextEmptyAfterSelection: function isBlockTextEmptyAfterSelection() {
    return _isBlockTextEmptyAfterSelection;
  },
  isDocumentEnd: function isDocumentEnd() {
    return _isDocumentEnd;
  },
  isEditorEmpty: function isEditorEmpty() {
    return _isEditorEmpty;
  },
  isFirstChild: function isFirstChild() {
    return _isFirstChild;
  },
  isLastChild: function isLastChild() {
    return _isLastChild;
  },
  isMarkActive: function isMarkActive() {
    return _isMarkActive;
  },
  isPointAtWordEnd: function isPointAtWordEnd() {
    return _isPointAtWordEnd;
  },
  isRangeAcrossBlocks: function isRangeAcrossBlocks() {
    return _isRangeAcrossBlocks;
  },
  isRangeInSameBlock: function isRangeInSameBlock() {
    return _isRangeInSameBlock;
  },
  isRangeInSingleText: function isRangeInSingleText() {
    return _isRangeInSingleText;
  },
  isSelectionAtBlockEnd: function isSelectionAtBlockEnd() {
    return _isSelectionAtBlockEnd;
  },
  isSelectionAtBlockStart: function isSelectionAtBlockStart() {
    return _isSelectionAtBlockStart;
  },
  isSelectionCoverBlock: function isSelectionCoverBlock() {
    return _isSelectionCoverBlock;
  },
  isSelectionExpanded: function isSelectionExpanded() {
    return _isSelectionExpanded;
  },
  isTextByPath: function isTextByPath() {
    return _isTextByPath;
  },
  isWordAfterTrigger: function isWordAfterTrigger() {
    return _isWordAfterTrigger;
  },
  moveChildren: function moveChildren() {
    return _moveChildren;
  },
  queryEditor: function queryEditor() {
    return _queryEditor;
  },
  removeMark: function removeMark() {
    return _removeMark;
  },
  removeNodeChildren: function removeNodeChildren() {
    return _removeNodeChildren;
  },
  removeSelectionMark: function removeSelectionMark() {
    return _removeSelectionMark;
  },
  replaceNode: function replaceNode() {
    return _replaceNode;
  },
  replaceNodeChildren: function replaceNodeChildren() {
    return _replaceNodeChildren;
  },
  selectEndOfBlockAboveSelection: function selectEndOfBlockAboveSelection() {
    return _selectEndOfBlockAboveSelection;
  },
  setMarks: function setMarks() {
    return _setMarks;
  },
  toggleMark: function toggleMark() {
    return _toggleMark;
  },
  toggleWrapNodes: function toggleWrapNodes() {
    return _toggleWrapNodes;
  },
  wrapNodeChildren: function wrapNodeChildren() {
    return _wrapNodeChildren;
  }
});
module.exports = __toCommonJS(src_exports);

// src/queries/findDescendant.ts
var import_slate = require("@udecode/slate");
var import_slate2 = require("slate");
var _findDescendant = function _findDescendant(editor, options) {
  try {
    var _options$at = options.at,
      at = _options$at === void 0 ? editor.selection : _options$at,
      _match = options.match,
      _options$reverse = options.reverse,
      reverse = _options$reverse === void 0 ? false : _options$reverse,
      _options$voids = options.voids,
      voids = _options$voids === void 0 ? false : _options$voids;
    if (!at) return;
    var from;
    var to;
    if (import_slate2.Span.isSpan(at)) {
      var _at2 = _slicedToArray(at, 2);
      from = _at2[0];
      to = _at2[1];
    } else if (import_slate2.Range.isRange(at)) {
      var first = (0, import_slate.getPath)(editor, at, {
        edge: "start"
      });
      var last2 = (0, import_slate.getPath)(editor, at, {
        edge: "end"
      });
      from = reverse ? last2 : first;
      to = reverse ? first : last2;
    }
    var root = [editor, []];
    if (import_slate2.Path.isPath(at)) {
      root = (0, import_slate.getNodeEntry)(editor, at);
    }
    var nodeEntries = (0, import_slate.getNodeDescendants)(root[0], {
      from: from,
      pass: function pass(_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
          n = _ref2[0];
        return voids ? false : (0, import_slate.isVoid)(editor, n);
      },
      reverse: reverse,
      to: to
    });
    var _iterator4 = _createForOfIteratorHelper(nodeEntries),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var _step4$value = _slicedToArray(_step4.value, 2),
          node = _step4$value[0],
          path = _step4$value[1];
        if ((0, import_slate.match)(node, path, _match)) {
          return [node, at.concat(path)];
        }
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  } catch (error) {
    return void 0;
  }
};

// src/queries/getAncestorNode.ts
var import_slate3 = require("@udecode/slate");
var _getAncestorNode = function _getAncestorNode(editor, path) {
  var _a;
  var selection = editor.selection;
  var at = path ? path[0] : (_a = selection == null ? void 0 : selection.focus) == null ? void 0 : _a.path[0];
  if (typeof at !== "number") return;
  return (0, import_slate3.getNodeEntry)(editor, [at]);
};

// src/queries/getBlockAbove.ts
var import_slate4 = require("@udecode/slate");
var _getBlockAbove = function _getBlockAbove(editor) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, import_slate4.getAboveNode)(editor, __spreadProps(__spreadValues({}, options), {
    block: true
  }));
};

// src/queries/getChildren.ts
var import_slate5 = require("@udecode/slate");
var _getChildren = function _getChildren(nodeEntry) {
  var _nodeEntry = _slicedToArray(nodeEntry, 2),
    node = _nodeEntry[0],
    path = _nodeEntry[1];
  if ((0, import_slate5.isAncestor)(node)) {
    var children = node.children;
    return children.map(function (child, index) {
      var childPath = path.concat([index]);
      return [child, childPath];
    });
  }
  return [];
};

// src/queries/getEdgeBlocksAbove.ts
var import_slate6 = require("@udecode/slate");
var _getEdgeBlocksAbove = function _getEdgeBlocksAbove(editor) {
  var _a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _b = _a,
    _at = _b.at,
    options = __objRest(_b, ["at"]);
  var at = _at != null ? _at : editor.selection;
  if (!at) return null;
  var _ref3 = (0, import_slate6.getEdgePoints)(editor, at != null ? at : editor.selection),
    _ref4 = _slicedToArray(_ref3, 2),
    start = _ref4[0],
    end = _ref4[1];
  var startBlock = _getBlockAbove(editor, __spreadValues({
    at: start
  }, options));
  if (!startBlock) return null;
  var endBlock = _getBlockAbove(editor, __spreadValues({
    at: end
  }, options));
  if (!endBlock) return null;
  return [startBlock, endBlock];
};

// src/queries/getLastChild.ts
var import_slate7 = require("@udecode/slate");
var import_slate8 = require("slate");
var _getLastChild = function _getLastChild(nodeEntry) {
  var _nodeEntry2 = _slicedToArray(nodeEntry, 2),
    node = _nodeEntry2[0],
    path = _nodeEntry2[1];
  if ((0, import_slate7.isText)(node)) return null;
  if (node.children.length === 0) return null;
  var children = node.children;
  return [children.at(-1), path.concat([children.length - 1])];
};
var _getLastChildPath = function _getLastChildPath(nodeEntry) {
  var lastChild = _getLastChild(nodeEntry);
  if (!lastChild) return nodeEntry[1].concat([-1]);
  return lastChild[1];
};
var _isLastChild = function _isLastChild(parentEntry, childPath) {
  var lastChildPath = _getLastChildPath(parentEntry);
  return import_slate8.Path.equals(lastChildPath, childPath);
};

// src/queries/getLastNodeByLevel.ts
var import_slate9 = require("@udecode/slate");
var _getLastChild2 = function getLastChild2(node, level) {
  if (!(level + 1) || !(0, import_slate9.isAncestor)(node)) return node;
  var children = node.children;
  var lastNode = children.at(-1);
  return _getLastChild2(lastNode, level - 1);
};
var _getLastNodeByLevel = function _getLastNodeByLevel(editor, level) {
  var children = editor.children;
  var lastNode = children.at(-1);
  if (!lastNode) return;
  var _ref5 = (0, import_slate9.getLastNode)(editor, []),
    _ref6 = _slicedToArray(_ref5, 2),
    lastPath = _ref6[1];
  return [_getLastChild2(lastNode, level - 1), lastPath.slice(0, level + 1)];
};

// src/queries/getMark.ts
var import_slate10 = require("@udecode/slate");
var _getMark = function _getMark(editor, key) {
  if (!editor) return;
  var marks = (0, import_slate10.getMarks)(editor);
  return marks == null ? void 0 : marks[key];
};

// src/queries/getNextNodeStartPoint.ts
var import_slate11 = require("@udecode/slate");
var _getNextNodeStartPoint = function _getNextNodeStartPoint(editor, at) {
  var nextEntry = (0, import_slate11.getNextNode)(editor, {
    at: at
  });
  if (!nextEntry) return;
  return (0, import_slate11.getStartPoint)(editor, nextEntry[1]);
};

// src/queries/getNextSiblingNodes.ts
var _getNextSiblingNodes = function _getNextSiblingNodes(ancestorEntry, path) {
  var _ancestorEntry = _slicedToArray(ancestorEntry, 2),
    ancestor = _ancestorEntry[0],
    ancestorPath = _ancestorEntry[1];
  var leafIndex = path[ancestorPath.length];
  var siblings = [];
  var ancestorChildren = ancestor.children;
  if (leafIndex + 1 < ancestor.children.length) {
    for (var i = leafIndex + 1; i < ancestor.children.length; i++) {
      siblings.push(ancestorChildren[i]);
    }
  }
  return siblings;
};

// src/queries/getNodesRange.ts
var import_slate12 = require("@udecode/slate");
var _getNodesRange = function _getNodesRange(editor, nodeEntries) {
  if (nodeEntries.length === 0) return;
  var firstBlockPath = nodeEntries[0][1];
  var lastBlockPath = nodeEntries.at(-1)[1];
  return (0, import_slate12.getRange)(editor, firstBlockPath, lastBlockPath);
};

// src/queries/getOperations.ts
var _getOperations = function _getOperations(editor) {
  return editor.operations;
};

// src/queries/getPointBeforeLocation.ts
var import_slate14 = require("@udecode/slate");
var import_castArray = __toESM(require("lodash/castArray.js"));
var import_map = __toESM(require("lodash/map.js"));

// src/queries/isRangeAcrossBlocks.ts
var import_slate13 = require("slate");
var _isRangeAcrossBlocks = function _isRangeAcrossBlocks(editor) {
  var _a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _b = _a,
    at = _b.at,
    options = __objRest(_b, ["at"]);
  if (!at) at = editor.selection;
  if (!at) return;
  var _import_slate13$Range = import_slate13.Range.edges(at),
    _import_slate13$Range2 = _slicedToArray(_import_slate13$Range, 2),
    start = _import_slate13$Range2[0],
    end = _import_slate13$Range2[1];
  var startBlock = _getBlockAbove(editor, __spreadValues({
    at: start
  }, options));
  var endBlock = _getBlockAbove(editor, __spreadValues({
    at: end
  }, options));
  if (!startBlock && !endBlock) return;
  if (!startBlock || !endBlock) return true;
  return !import_slate13.Path.equals(startBlock[1], endBlock[1]);
};

// src/queries/getPointBeforeLocation.ts
var _getPointBeforeLocation = function _getPointBeforeLocation(editor, at, options) {
  var _a;
  if (!options || !options.match && !options.matchString) {
    return (0, import_slate14.getPointBefore)(editor, at, options);
  }
  var unitOffset = !options.unit || options.unit === "offset";
  var matchStrings = options.matchString ? (0, import_castArray.default)(options.matchString) : [""];
  var matchByRegex = (_a = options.matchByRegex) != null ? _a : false;
  var point;
  matchStrings.some(function (matchString) {
    var _a2, _b;
    var beforeAt = at;
    var previousBeforePoint = (0, import_slate14.getPoint)(editor, at, {
      edge: "end"
    });
    var stackLength = matchString.length + 1;
    var stack = Array.from({
      length: stackLength
    });
    var count = 0;
    while (true) {
      var beforePoint = (0, import_slate14.getPointBefore)(editor, beforeAt, options);
      if (!beforePoint) return;
      if (_isRangeAcrossBlocks(editor, {
        at: {
          anchor: beforePoint,
          focus: previousBeforePoint
        }
      })) {
        return;
      }
      var beforeString = (0, import_slate14.getEditorString)(editor, {
        anchor: beforePoint,
        focus: previousBeforePoint
      });
      var beforeStringToMatch = beforeString;
      if (unitOffset && stackLength) {
        stack.unshift({
          point: beforePoint,
          text: beforeString
        });
        stack.pop();
        beforeStringToMatch = (0, import_map.default)(stack.slice(0, -1), "text").join("");
      }
      var isMatched = matchByRegex ? !!matchString.match(beforeStringToMatch) : beforeStringToMatch === matchString;
      if (isMatched || ((_a2 = options.match) == null ? void 0 : _a2.call(options, {
        at: at,
        beforePoint: beforePoint,
        beforeString: beforeStringToMatch
      }))) {
        if (options.afterMatch) {
          if (stackLength && unitOffset) {
            point = (_b = stack.at(-1)) == null ? void 0 : _b.point;
            return !!point;
          }
          point = previousBeforePoint;
          return true;
        }
        point = beforePoint;
        return true;
      }
      previousBeforePoint = beforePoint;
      beforeAt = beforePoint;
      count += 1;
      if (!options.skipInvalid && (!matchString || count >= matchString.length)) return;
    }
  });
  return point;
};

// src/queries/getPointFromLocation.ts
var import_slate15 = require("slate");
var _getPointFromLocation = function _getPointFromLocation(editor) {
  var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref7$at = _ref7.at,
    at = _ref7$at === void 0 ? editor.selection : _ref7$at,
    focus = _ref7.focus;
  var point;
  if (import_slate15.Range.isRange(at)) point = focus ? at.focus : at.anchor;
  if (import_slate15.Point.isPoint(at)) point = at;
  if (import_slate15.Path.isPath(at)) point = {
    offset: 0,
    path: at
  };
  return point;
};

// src/queries/getPointNextToVoid.ts
var import_slate16 = require("@udecode/slate");
var import_slate17 = require("slate");
var _getPointNextToVoid = function _getPointNextToVoid(editor, _ref8) {
  var after = _ref8.after,
    at = _ref8.at;
  var startVoid = (0, import_slate16.getVoidNode)(editor, {
    at: at,
    mode: "highest"
  });
  if (startVoid) {
    var blockAbove = _getBlockAbove(editor, {
      at: at
    });
    if (blockAbove) {
      var nextPoint = after ? (0, import_slate16.getPointAfter)(editor, at) : (0, import_slate16.getPointBefore)(editor, at);
      if (nextPoint && blockAbove && import_slate17.Path.isAncestor(blockAbove[1], nextPoint.path)) {
        at = nextPoint;
      }
    }
  }
  return at;
};

// src/queries/getPreviousBlockById.ts
var import_slate18 = require("@udecode/slate");
var _getPreviousBlockById = function _getPreviousBlockById(editor, id, query) {
  var entry = (0, import_slate18.findNode)(editor, {
    match: {
      id: id
    }
  });
  if (entry) {
    var prevEntry = (0, import_slate18.getPreviousNode)(editor, {
      at: entry[1]
    });
    if ((prevEntry == null ? void 0 : prevEntry[0].id) && (0, import_slate18.isBlock)(editor, prevEntry[0])) {
      return prevEntry;
    }
  }
  var found = false;
  var _nodes = (0, import_slate18.getNodeEntries)(editor, {
    at: [],
    match: function match(n) {
      if (!(0, import_slate18.isBlock)(editor, n) || !n.id) return false;
      if (n.id === id) {
        found = true;
        return false;
      }
      return found && n.id !== id && (0, import_slate18.queryNode)([n, []], query);
    },
    mode: "highest",
    reverse: true
  });
  var nodeEntries = Array.from(_nodes);
  if (nodeEntries.length > 0) {
    return nodeEntries[0];
  }
  if (!found) return;
  var _entries = (0, import_slate18.getNodeEntries)(editor, {
    at: [],
    match: function match(n) {
      return (0, import_slate18.isBlock)(editor, n) && !!n.id && (0, import_slate18.queryNode)([n, []], query);
    },
    mode: "highest"
  });
  var firstNodeEntry = Array.from(_entries);
  if (firstNodeEntry.length > 0) {
    var _firstNodeEntry$ = _slicedToArray(firstNodeEntry[0], 2),
      path = _firstNodeEntry$[1];
    path[path.length - 1] = path.at(-1) - 1;
    return [null, path];
  }
};

// src/queries/getPreviousNodeEndPoint.ts
var import_slate19 = require("@udecode/slate");
var _getPreviousNodeEndPoint = function _getPreviousNodeEndPoint(editor, at) {
  var prevEntry = (0, import_slate19.getPreviousNode)(editor, {
    at: at
  });
  if (!prevEntry) return;
  return (0, import_slate19.getEndPoint)(editor, prevEntry[1]);
};

// src/queries/getPreviousPath.ts
var _getPreviousPath = function _getPreviousPath(path) {
  if (path.length === 0) return;
  var last2 = path.at(-1);
  if (last2 <= 0) return;
  return path.slice(0, -1).concat(last2 - 1);
};

// src/queries/getPreviousSiblingNode.ts
var import_slate20 = require("@udecode/slate");
var import_last = __toESM(require("lodash/last.js"));
var _getPreviousSiblingNode = function _getPreviousSiblingNode(editor, path) {
  var index = (0, import_last.default)(path);
  if (index > 0) {
    var previousSiblingIndex = index - 1;
    var previousSiblingPath = path.slice(0, -1).concat([previousSiblingIndex]);
    var previousSiblingNode = (0, import_slate20.getNode)(editor, previousSiblingPath);
    return previousSiblingNode ? [previousSiblingNode, previousSiblingPath] : void 0;
  }
};

// src/queries/getRangeBefore.ts
var import_slate21 = require("@udecode/slate");
var _getRangeBefore = function _getRangeBefore(editor, at, options) {
  var anchor = _getPointBeforeLocation(editor, at, options);
  if (!anchor) return;
  var focus = (0, import_slate21.getPoint)(editor, at, {
    edge: "end"
  });
  return {
    anchor: anchor,
    focus: focus
  };
};

// src/queries/getRangeFromBlockStart.ts
var import_slate22 = require("@udecode/slate");
var _getRangeFromBlockStart = function _getRangeFromBlockStart(editor) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _a;
  var path = (_a = _getBlockAbove(editor, options)) == null ? void 0 : _a[1];
  if (!path) return;
  var start = (0, import_slate22.getStartPoint)(editor, path);
  var focus = _getPointFromLocation(editor, options);
  if (!focus) return;
  return {
    anchor: start,
    focus: focus
  };
};

// src/queries/getSelectionText.ts
var import_slate23 = require("@udecode/slate");
var _getSelectionText = function _getSelectionText(editor) {
  return (0, import_slate23.getEditorString)(editor, editor.selection);
};

// src/queries/isAncestorEmpty.ts
var import_slate24 = require("@udecode/slate");
var _isAncestorEmpty = function _isAncestorEmpty(editor, node) {
  return !(0, import_slate24.getNodeString)(node) && !node.children.some(function (n) {
    return (0, import_slate24.isInline)(editor, n);
  });
};

// src/queries/isBlockAboveEmpty.ts
var _isBlockAboveEmpty = function _isBlockAboveEmpty(editor) {
  var _a;
  var block = (_a = _getBlockAbove(editor)) == null ? void 0 : _a[0];
  if (!block) return false;
  return _isAncestorEmpty(editor, block);
};

// src/queries/isBlockTextEmptyAfterSelection.ts
var import_slate25 = require("@udecode/slate");
var _isBlockTextEmptyAfterSelection = function _isBlockTextEmptyAfterSelection(editor) {
  if (!editor.selection) return false;
  var blockAbove = _getBlockAbove(editor);
  if (!blockAbove) return false;
  var cursor = editor.selection.focus;
  var selectionParentEntry = (0, import_slate25.getParentNode)(editor, editor.selection);
  if (!selectionParentEntry) return false;
  var _selectionParentEntry = _slicedToArray(selectionParentEntry, 2),
    selectionParentPath = _selectionParentEntry[1];
  if (!(0, import_slate25.isEndPoint)(editor, cursor, selectionParentPath)) return false;
  var siblingNodes = _getNextSiblingNodes(blockAbove, cursor.path);
  if (siblingNodes.length > 0) {
    var _iterator5 = _createForOfIteratorHelper(siblingNodes),
      _step5;
    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var siblingNode = _step5.value;
        if ((0, import_slate25.isText)(siblingNode) && siblingNode.text) {
          return false;
        }
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  } else {
    return (0, import_slate25.isEndPoint)(editor, cursor, blockAbove[1]);
  }
  return true;
};

// src/queries/isDocumentEnd.ts
var import_slate26 = require("@udecode/slate");
var import_slate27 = require("slate");
var _isDocumentEnd = function _isDocumentEnd(editor) {
  if (editor.selection) {
    var point = editor.selection.focus;
    var endPoint = (0, import_slate26.getEndPoint)(editor, []);
    return endPoint.offset === 0 && (0, import_slate26.isEndPoint)(editor, point, point) && import_slate27.Path.equals(import_slate27.Path.next(import_slate27.Path.parent(point.path)), endPoint.path);
  }
  return false;
};

// src/queries/isEditorEmpty.ts
var import_slate28 = require("@udecode/slate");
var _isEditorEmpty = function _isEditorEmpty(editor) {
  return editor.children.length === 1 && (0, import_slate28.isElementEmpty)(editor, editor.children[0]);
};

// src/queries/isFirstChild.ts
var _isFirstChild = function _isFirstChild(path) {
  return path.at(-1) === 0;
};

// src/queries/isMarkActive.ts
var import_utils = require("@udecode/utils");
var _isMarkActive = function _isMarkActive(editor, type) {
  return (0, import_utils.isDefined)(_getMark(editor, type));
};

// src/queries/isPointAtWordEnd.ts
var import_slate29 = require("@udecode/slate");
var AFTER_MATCH_REGEX = /^(?:\s|$)/;
var _isPointAtWordEnd = function _isPointAtWordEnd(editor, _ref9) {
  var at = _ref9.at;
  var after = (0, import_slate29.getPointAfter)(editor, at);
  var afterRange = (0, import_slate29.getRange)(editor, at, after);
  var afterText = (0, import_slate29.getEditorString)(editor, afterRange);
  return !!afterText.match(AFTER_MATCH_REGEX);
};

// src/queries/isRangeInSameBlock.ts
var import_slate30 = require("slate");
var _isRangeInSameBlock = function _isRangeInSameBlock(editor) {
  var _a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _b = _a,
    at = _b.at,
    options = __objRest(_b, ["at"]);
  if (!at) at = editor.selection;
  if (!at) return;
  var _import_slate30$Range = import_slate30.Range.edges(at),
    _import_slate30$Range2 = _slicedToArray(_import_slate30$Range, 2),
    start = _import_slate30$Range2[0],
    end = _import_slate30$Range2[1];
  var startBlock = _getBlockAbove(editor, __spreadValues({
    at: start
  }, options));
  var endBlock = _getBlockAbove(editor, __spreadValues({
    at: end
  }, options));
  if (!startBlock || !endBlock) return;
  return import_slate30.Path.equals(startBlock[1], endBlock[1]);
};

// src/queries/isRangeInSingleText.ts
var import_slate31 = require("slate");
var _isRangeInSingleText = function _isRangeInSingleText(at) {
  var _import_slate31$Range = import_slate31.Range.edges(at),
    _import_slate31$Range2 = _slicedToArray(_import_slate31$Range, 2),
    start = _import_slate31$Range2[0],
    end = _import_slate31$Range2[1];
  return import_slate31.Path.equals(start.path, end.path);
};

// src/queries/isSelectionAtBlockEnd.ts
var import_slate32 = require("@udecode/slate");
var _isSelectionAtBlockEnd = function _isSelectionAtBlockEnd(editor, options) {
  var _a, _b;
  var path = (_a = _getBlockAbove(editor, options)) == null ? void 0 : _a[1];
  return !!path && (0, import_slate32.isEndPoint)(editor, (_b = editor.selection) == null ? void 0 : _b.focus, path);
};

// src/queries/isSelectionAtBlockStart.ts
var import_slate33 = require("@udecode/slate");
var _isSelectionAtBlockStart = function _isSelectionAtBlockStart(editor, options) {
  var _a;
  var selection = editor.selection;
  if (!selection) return false;
  var path = (_a = _getBlockAbove(editor, options)) == null ? void 0 : _a[1];
  if (!path) return false;
  return (0, import_slate33.isStartPoint)(editor, selection.focus, path) || (0, import_slate33.isExpanded)(editor.selection) && (0, import_slate33.isStartPoint)(editor, selection.anchor, path);
};

// src/queries/isSelectionCoverBlock.ts
var _isSelectionCoverBlock = function _isSelectionCoverBlock(editor) {
  var _a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _b = _a,
    at = _b.at,
    options = __objRest(_b, ["at"]);
  return _isSelectionAtBlockEnd(editor, options) && _isSelectionAtBlockStart(editor, options) && _isRangeInSameBlock(editor, options);
};

// src/queries/isSelectionExpanded.ts
var import_slate34 = require("@udecode/slate");
var _isSelectionExpanded = function _isSelectionExpanded(editor) {
  return (0, import_slate34.isExpanded)(editor.selection);
};

// src/queries/isTextByPath.ts
var import_slate35 = require("@udecode/slate");
var _isTextByPath = function _isTextByPath(editor, path) {
  var node = (0, import_slate35.getNode)(editor, path);
  return (0, import_slate35.isText)(node);
};

// src/queries/isWordAfterTrigger.ts
var import_slate36 = require("@udecode/slate");
var import_utils2 = require("@udecode/utils");
var _isWordAfterTrigger = function _isWordAfterTrigger(editor, _ref10) {
  var at = _ref10.at,
    trigger = _ref10.trigger;
  var wordBefore = (0, import_slate36.getPointBefore)(editor, at, {
    unit: "word"
  });
  var before = wordBefore && (0, import_slate36.getPointBefore)(editor, wordBefore);
  var beforeRange = before && (0, import_slate36.getRange)(editor, before, at);
  var beforeText = (0, import_slate36.getEditorString)(editor, beforeRange);
  var escapedTrigger = (0, import_utils2.escapeRegExp)(trigger);
  var beforeRegex = new RegExp("^".concat(escapedTrigger, "([\\w|\xC0-\xD6\xD8-\xF6\xF8-\xFF|\u0430-\u044F\u0410-\u042F\u0451\u0401]+)$"));
  var match2 = beforeText ? beforeText.match(beforeRegex) : null;
  return {
    match: match2,
    range: beforeRange
  };
};

// src/queries/queryEditor.ts
var import_slate37 = require("@udecode/slate");
var import_castArray2 = __toESM(require("lodash/castArray.js"));
var _queryEditor = function _queryEditor(editor) {
  var _ref11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    allow = _ref11.allow,
    _ref11$at = _ref11.at,
    at = _ref11$at === void 0 ? editor.selection || [] : _ref11$at,
    exclude = _ref11.exclude,
    filter = _ref11.filter,
    selectionAtBlockEnd = _ref11.selectionAtBlockEnd,
    selectionAtBlockStart = _ref11.selectionAtBlockStart;
  if (filter && !filter(editor) || selectionAtBlockStart && !_isSelectionAtBlockStart(editor) || selectionAtBlockEnd && !_isSelectionAtBlockEnd(editor)) {
    return false;
  }
  var allows = (0, import_castArray2.default)(allow);
  if (allows.length > 0 && !(0, import_slate37.someNode)(editor, {
    at: at,
    match: {
      type: allows
    }
  })) {
    return false;
  }
  var excludes = (0, import_castArray2.default)(exclude);
  if (excludes.length > 0 && (0, import_slate37.someNode)(editor, {
    at: at,
    match: {
      type: excludes
    }
  })) {
    return false;
  }
  return true;
};

// src/transforms/insertElements.ts
var import_slate38 = require("@udecode/slate");
var _insertElements = function _insertElements(editor, nodes, options) {
  (0, import_slate38.insertNodes)(editor, nodes, options);
};

// src/transforms/insertEmptyElement.ts
var import_slate39 = require("@udecode/slate");
var _insertEmptyElement = function _insertEmptyElement(editor, type, options) {
  _insertElements(editor, {
    children: [{
      text: ""
    }],
    type: type
  }, (0, import_slate39.getQueryOptions)(editor, options));
};

// src/transforms/moveChildren.ts
var import_slate40 = require("@udecode/slate");
var import_slate41 = require("slate");
var _moveChildren = function _moveChildren(editor, _ref12) {
  var at = _ref12.at,
    _ref12$fromStartIndex = _ref12.fromStartIndex,
    fromStartIndex = _ref12$fromStartIndex === void 0 ? 0 : _ref12$fromStartIndex,
    match2 = _ref12.match,
    to = _ref12.to;
  var moved = 0;
  var parentPath = import_slate41.Path.isPath(at) ? at : at[1];
  var parentNode = import_slate41.Path.isPath(at) ? (0, import_slate40.getNode)(editor, parentPath) : at[0];
  if (!parentNode) return moved;
  if (!(0, import_slate40.isBlock)(editor, parentNode)) return moved;
  for (var i = parentNode.children.length - 1; i >= fromStartIndex; i--) {
    var childPath = [].concat(_toConsumableArray(parentPath), [i]);
    var childNode = (0, import_slate40.getNode)(editor, childPath);
    if (!match2 || childNode && match2([childNode, childPath])) {
      (0, import_slate40.moveNodes)(editor, {
        at: childPath,
        to: to
      });
      moved++;
    }
  }
  return moved;
};

// src/transforms/removeMark.ts
var import_slate42 = require("@udecode/slate");
var import_castArray3 = __toESM(require("lodash/castArray.js"));
var import_slate43 = require("slate");
var _removeMark = function _removeMark(editor, _a) {
  var _b = _a,
    at = _b.at,
    key = _b.key,
    _b$shouldChange = _b.shouldChange,
    shouldChange = _b$shouldChange === void 0 ? true : _b$shouldChange,
    rest = __objRest(_b, ["at", "key", "shouldChange"]);
  var _a2;
  var selection = at != null ? at : editor.selection;
  key = (0, import_castArray3.default)(key);
  if (selection) {
    if (import_slate43.Range.isRange(selection) && import_slate43.Range.isExpanded(selection)) {
      (0, import_slate42.unsetNodes)(editor, key, __spreadValues({
        at: selection,
        match: import_slate42.isText,
        split: true
      }, rest));
    } else if (editor.selection) {
      var marks = (_a2 = (0, import_slate42.getMarks)(editor)) != null ? _a2 : {};
      key.forEach(function (k) {
        delete marks[k];
      });
      editor.marks = marks;
      shouldChange && editor.onChange();
    }
  }
};

// src/transforms/removeNodeChildren.ts
var import_slate44 = require("@udecode/slate");
var _removeNodeChildren = function _removeNodeChildren(editor, path, options) {
  (0, import_slate44.withoutNormalizing)(editor, function () {
    var _iterator6 = _createForOfIteratorHelper((0, import_slate44.getNodeChildren)(editor, path, {
        reverse: true
      })),
      _step6;
    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var _step6$value = _slicedToArray(_step6.value, 2),
          childPath = _step6$value[1];
        (0, import_slate44.removeNodes)(editor, __spreadProps(__spreadValues({}, options), {
          at: childPath
        }));
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
  });
};

// src/transforms/removeSelectionMark.ts
var import_slate45 = require("@udecode/slate");
var _removeSelectionMark = function _removeSelectionMark(editor) {
  var marks = (0, import_slate45.getMarks)(editor);
  if (!marks) return;
  Object.keys(marks).forEach(function (key) {
    (0, import_slate45.removeEditorMark)(editor, key);
  });
};

// src/transforms/replaceNode.ts
var import_slate46 = require("@udecode/slate");
var _replaceNode = function _replaceNode(editor, _ref13) {
  var at = _ref13.at,
    insertOptions = _ref13.insertOptions,
    nodes = _ref13.nodes,
    removeOptions = _ref13.removeOptions;
  (0, import_slate46.withoutNormalizing)(editor, function () {
    (0, import_slate46.removeNodes)(editor, __spreadProps(__spreadValues({}, removeOptions), {
      at: at
    }));
    (0, import_slate46.insertNodes)(editor, nodes, __spreadProps(__spreadValues({}, insertOptions), {
      at: at
    }));
  });
};

// src/transforms/replaceNodeChildren.ts
var import_slate47 = require("@udecode/slate");
var _replaceNodeChildren = function _replaceNodeChildren(editor, _ref14) {
  var at = _ref14.at,
    insertOptions = _ref14.insertOptions,
    nodes = _ref14.nodes,
    removeOptions = _ref14.removeOptions;
  (0, import_slate47.withoutNormalizing)(editor, function () {
    _removeNodeChildren(editor, at, removeOptions);
    (0, import_slate47.insertNodes)(editor, nodes, __spreadProps(__spreadValues({}, insertOptions), {
      at: at.concat([0])
    }));
  });
};

// src/transforms/selectEndOfBlockAboveSelection.ts
var import_slate48 = require("@udecode/slate");
var _selectEndOfBlockAboveSelection = function _selectEndOfBlockAboveSelection(editor) {
  var _a;
  var path = (_a = _getBlockAbove(editor)) == null ? void 0 : _a[1];
  path && (0, import_slate48.select)(editor, (0, import_slate48.getEndPoint)(editor, path));
};

// src/transforms/setMarks.ts
var import_slate49 = require("@udecode/slate");
var import_castArray4 = __toESM(require("lodash/castArray.js"));
var _setMarks = function _setMarks(editor, marks) {
  var clear = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  if (!editor.selection) return;
  (0, import_slate49.withoutNormalizing)(editor, function () {
    var clears = (0, import_castArray4.default)(clear);
    _removeMark(editor, {
      key: clears
    });
    _removeMark(editor, {
      key: Object.keys(marks)
    });
    Object.keys(marks).forEach(function (key) {
      editor.addMark(key, marks[key]);
    });
  });
};

// src/transforms/toggleMark.ts
var import_slate50 = require("@udecode/slate");
var import_castArray5 = __toESM(require("lodash/castArray.js"));
var _toggleMark = function _toggleMark(editor, _ref15) {
  var clear = _ref15.clear,
    key = _ref15.key;
  if (!editor.selection) return;
  (0, import_slate50.withoutNormalizing)(editor, function () {
    var isActive = _isMarkActive(editor, key);
    if (isActive) {
      editor.removeMark(key);
      return;
    }
    if (clear) {
      var clears = (0, import_castArray5.default)(clear);
      _removeMark(editor, {
        key: clears
      });
    }
    editor.addMark(key, true);
  });
};

// src/transforms/toggleWrapNodes.ts
var import_slate51 = require("@udecode/slate");
var _toggleWrapNodes = function _toggleWrapNodes(editor, type) {
  if ((0, import_slate51.someNode)(editor, {
    match: {
      type: type
    }
  })) {
    (0, import_slate51.unwrapNodes)(editor, {
      match: {
        type: type
      }
    });
  } else {
    (0, import_slate51.wrapNodes)(editor, {
      children: [],
      type: type
    });
  }
};

// src/transforms/wrapNodeChildren.ts
var import_slate52 = require("@udecode/slate");
var _wrapNodeChildren = function _wrapNodeChildren(editor, element, options) {
  var path = options == null ? void 0 : options.at;
  var node = (0, import_slate52.getNode)(editor, path);
  if (!(node == null ? void 0 : node.children)) return;
  (0, import_slate52.withoutNormalizing)(editor, function () {
    var firstChildPath = path.concat([0]);
    (0, import_slate52.wrapNodes)(editor, element, __spreadProps(__spreadValues({}, options), {
      at: firstChildPath
    }));
    if (node.children.length < 2) return;
    _moveChildren(editor, {
      at: path,
      fromStartIndex: 1,
      to: firstChildPath.concat([1])
    });
  });
};

// src/utils/createDocumentNode.ts
var _createDocumentNode = function _createDocumentNode() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "p";
  var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var remaining = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return [{
    children: [{
      children: [{
        text: text
      }],
      type: type
    }].concat(_toConsumableArray(remaining))
  }];
};

// src/utils/createNode.ts
var _createNode = function _createNode() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "p";
  var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return {
    children: [{
      text: text
    }],
    type: type
  };
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  createDocumentNode: _createDocumentNode,
  createNode: _createNode,
  findDescendant: _findDescendant,
  getAncestorNode: _getAncestorNode,
  getBlockAbove: _getBlockAbove,
  getChildren: _getChildren,
  getEdgeBlocksAbove: _getEdgeBlocksAbove,
  getLastChild: _getLastChild,
  getLastChildPath: _getLastChildPath,
  getLastNodeByLevel: _getLastNodeByLevel,
  getMark: _getMark,
  getNextNodeStartPoint: _getNextNodeStartPoint,
  getNextSiblingNodes: _getNextSiblingNodes,
  getNodesRange: _getNodesRange,
  getOperations: _getOperations,
  getPointBeforeLocation: _getPointBeforeLocation,
  getPointFromLocation: _getPointFromLocation,
  getPointNextToVoid: _getPointNextToVoid,
  getPreviousBlockById: _getPreviousBlockById,
  getPreviousNodeEndPoint: _getPreviousNodeEndPoint,
  getPreviousPath: _getPreviousPath,
  getPreviousSiblingNode: _getPreviousSiblingNode,
  getRangeBefore: _getRangeBefore,
  getRangeFromBlockStart: _getRangeFromBlockStart,
  getSelectionText: _getSelectionText,
  insertElements: _insertElements,
  insertEmptyElement: _insertEmptyElement,
  isAncestorEmpty: _isAncestorEmpty,
  isBlockAboveEmpty: _isBlockAboveEmpty,
  isBlockTextEmptyAfterSelection: _isBlockTextEmptyAfterSelection,
  isDocumentEnd: _isDocumentEnd,
  isEditorEmpty: _isEditorEmpty,
  isFirstChild: _isFirstChild,
  isLastChild: _isLastChild,
  isMarkActive: _isMarkActive,
  isPointAtWordEnd: _isPointAtWordEnd,
  isRangeAcrossBlocks: _isRangeAcrossBlocks,
  isRangeInSameBlock: _isRangeInSameBlock,
  isRangeInSingleText: _isRangeInSingleText,
  isSelectionAtBlockEnd: _isSelectionAtBlockEnd,
  isSelectionAtBlockStart: _isSelectionAtBlockStart,
  isSelectionCoverBlock: _isSelectionCoverBlock,
  isSelectionExpanded: _isSelectionExpanded,
  isTextByPath: _isTextByPath,
  isWordAfterTrigger: _isWordAfterTrigger,
  moveChildren: _moveChildren,
  queryEditor: _queryEditor,
  removeMark: _removeMark,
  removeNodeChildren: _removeNodeChildren,
  removeSelectionMark: _removeSelectionMark,
  replaceNode: _replaceNode,
  replaceNodeChildren: _replaceNodeChildren,
  selectEndOfBlockAboveSelection: _selectEndOfBlockAboveSelection,
  setMarks: _setMarks,
  toggleMark: _toggleMark,
  toggleWrapNodes: _toggleWrapNodes,
  wrapNodeChildren: _wrapNodeChildren
});